var util = require("./util");
var roleMap = {
    none: null,
    span: "Span",
    p: "P",
    h: "H",
    h1: "H1",
    h2: "H2",
    h3: "H3",
    h4: "H4",
    h5: "H5",
    h6: "H6",
    h7: "H7",
    list: "L",
    "list-item": "LI",
    "list-label": "Lbl",
    "list-body": "LBody",
    table: "Table",
    "table-row": "TR",
    "table-cell": "TD",
    "table-heading": "TH",
    section: "Sect",
    "block-quote": "BlockQuote",
    caption: "Caption",
    toc: "TOC",
    "toc-item": "TOCI",
    quote: "Quote",
    note: "Note",
    ref: "Reference",
    code: "Code",
    link: "Link",
    annotation: "Annot",
    img: "Figure",
    "page-header": "page-header",
    "page-footer": "page-footer",
    hidden: "hidden",
};
function hasA11y(doc) {
    if (typeof doc.structElem !== "function")
        return false;
    return doc.__a11yStructParent !== "hidden";
}
// function text(cursor, role, fn, thisObj) {
// 	var doc = cursor.doc;
// 	if (!hasA11y(doc)) {
// 		return fn.call(thisObj || null);
// 	}
// 	var mappedRole = roleMap[role] || "P";
//
//     var ret;
// 	doc.structElem(mappedRole, function () {
// 	    doc.markedContent(function () {
// 	        ret = fn.call(thisObj || null);
// 	    });
// 	});
//     return ret;
// }
function marked(cursor, fn, options, thisObj) {
    if (options === void 0) { options = {}; }
    if (thisObj === void 0) { thisObj = null; }
    var doc = cursor.doc;
    if (!hasA11y(doc)) {
        return fn.call(thisObj);
    }
    var ret;
    doc.markedContent(function () {
        ret = fn.call(thisObj);
    }, options);
    return ret;
}
function link(cursor, x, y, w, h, options) {
    var doc = cursor.doc;
    if (!hasA11y(doc)) {
        doc.link(x, y, w, h, options);
    }
    else {
        doc.a11yLink(x, y, w, h, options);
    }
}
function structure(cursor, role, options, fn, thisObj) {
    var doc = cursor.doc;
    if (typeof options === "function") {
        thisObj = fn;
        fn = options;
        options = null;
    }
    var mappedRole = role && roleMap[role];
    if (!hasA11y(doc) || !mappedRole) {
        return fn.call(thisObj || null);
    }
    options = util.cloneObj(options || {});
    options.type = mappedRole;
    var ret;
    if (mappedRole === "hidden") {
        doc.__a11yStructStack = (doc.__a11yStructStack || []).concat(doc.__a11yStructParent);
        doc.__a11yStructParent = "hidden";
        doc.artifact(function () {
            ret = fn.call(thisObj || null);
        });
        doc.__a11yStructParent = doc.__a11yStructStack.pop();
    }
    else if (mappedRole === "page-header" || mappedRole === "page-footer") {
        var properties = {
            type: "Pagination",
            subtype: mappedRole === "page-header" ? "Header" : "Footer",
        };
        doc.__a11yStructStack = (doc.__a11yStructStack || []).concat(doc.__a11yStructParent);
        doc.__a11yStructParent = "hidden";
        doc.artifactWithProperties(properties, function () {
            ret = fn.call(thisObj || null);
        });
        doc.__a11yStructParent = doc.__a11yStructStack.pop();
    }
    else {
        doc.structElem(options, function () {
            doc.__a11yStructStack = (doc.__a11yStructStack || []).concat(doc.__a11yStructParent);
            doc.__a11yStructParent = options;
            ret = fn.call(thisObj || null);
            doc.__a11yStructParent = doc.__a11yStructStack.pop();
        });
    }
    return ret;
}
function artifact(cursor, fn, thisObj) {
    var doc = cursor.doc;
    if (!hasA11y(doc)) {
        return fn.call(thisObj || null);
    }
    var ret;
    doc.artifact(function () {
        ret = fn.call(thisObj || null);
    });
    return ret;
}
module.exports = {
    marked: marked,
    link: link,
    structure: structure,
    artifact: artifact,
};
//# sourceMappingURL=module.js.map